export const masterCategoryToSlug = (label) =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const masterCategoryImagePath = (slug) => `/images/master-categories/${slug}.webp`;

export const MASTER_CATEGORY_IMAGE_BY_SLUG = {
  electronics: "/images/master-categories/electronics.webp",
  "apparel-and-fashion-accessories": "/images/master-categories/apparel-and-fashion-accessories.webp",
  "home-appliances": "/images/master-categories/home-appliances.webp",
  furniture: "/images/master-categories/furniture.webp",
  "industrial-equipment": "/images/master-categories/industrial-equipment.webp",
  tools: "/images/master-categories/tools.webp",
  "kids-and-toys": "/images/master-categories/kids-and-toys.webp",
  "sports-equipment": "/images/master-categories/sports-equipment.webp",
  books: "/images/master-categories/books.webp",
  "medical-equipments": "/images/master-categories/medical-equipments.webp",
  "healthcare-products": "/images/master-categories/healthcare-products.webp",
  "beauty-and-personal-care": "/images/master-categories/beauty-and-personal-care.webp",
  "automotive-parts": "/images/master-categories/automotive-parts.webp",
  "food-and-beverages": "/images/master-categories/food-and-beverages.webp",
  "packaging-materials": "/images/master-categories/packaging-materials.webp",
  "office-supplies": "/images/master-categories/office-supplies.webp",
  "cleaning-supplies": "/images/master-categories/cleaning-supplies.webp",
  "construction-materials": "/images/master-categories/construction-materials.webp",
  "agricultural-products": "/images/master-categories/agricultural-products.webp",
  "agricultural-equipments": "/images/master-categories/agricultural-equipments.webp",
  "renewable-energy-products": "/images/master-categories/renewable-energy-products.webp",
  "craft-supplies": "/images/master-categories/craft-supplies.webp",
  "industrial-safety-equipments": "/images/master-categories/industrial-safety-equipments.webp",
  others: "/images/master-categories/others.webp",
  "maintenance-repairs-and-operations-equipments":
    "/images/master-categories/maintenance-repairs-and-operations-equipments.webp",
  "pet-supplies": "/images/master-categories/pet-supplies.webp",
  "electronic-components": "/images/master-categories/electronic-components.webp",
  "renewable-energy-and-electrical": "/images/master-categories/renewable-energy-and-electrical.webp",
  "home-and-garden": "/images/master-categories/home-and-garden.webp",
  "packaging-and-printing": "/images/master-categories/packaging-and-printing.webp",
  "health-and-medical": "/images/master-categories/health-and-medical.webp",
  "sports-and-entertainment": "/images/master-categories/sports-and-entertainment.webp",
  scrap: "/images/master-categories/scrap.webp",
  "home-care": "/images/master-categories/home-care.webp",
  "raw-material": "/images/master-categories/raw-material.webp",
  "mobile-phone-and-accessories": "/images/master-categories/mobile-phone-and-accessories.webp",
  "shoes-and-accessories": "/images/master-categories/shoes-and-accessories.webp",
  "luggage-bags-and-cases": "/images/master-categories/luggage-bags-and-cases.webp",
  "construction-and-real-estate": "/images/master-categories/construction-and-real-estate.webp",
  "lights-and-lighting": "/images/master-categories/lights-and-lighting.webp",
};

export default masterCategoryImagePath;
